import { StyledCtaSection, StyledLink } from './CtaSection.styles';

type CtaSectionProps = {
  ctas?: NonNullable<Queries.HEADERFragment['headerElements']['cta_section']>['value'];
  ctaIsOnNavBar?: boolean;
};

const CtaSection = ({ ctas, ctaIsOnNavBar }: CtaSectionProps) => (
  <StyledCtaSection hasOneCTA={ctas?.length === 1} ctaIsOnNavBar={ctaIsOnNavBar}>
    {ctas?.map((link, index) => (
      <StyledLink
        {...link}
        key={link.system.id}
        variant={index === 1 ? 'secondary_small' : 'primary_small'}
      />
    ))}
  </StyledCtaSection>
);

export default CtaSection;
